import type { IWindow, NavigateParams, NavigateResponse } from 'oidc-client-ts';

/**
 * A window-like object that wraps an Office.js Dialog to handle silent sign-in.
 */
export default class OidcSilentRenewWindow implements IWindow {
  private dialog: Office.Dialog | undefined;

  public async navigate(params: NavigateParams): Promise<NavigateResponse> {
    return new Promise<NavigateResponse>((resolve, reject) => {
      const dialogUrl = params.url;

      const dialogOptions: Office.DialogOptions = {
        width: 1,
        height: 1,
        displayInIframe: true,
        promptBeforeOpen: false,
      };

      Office.context.ui.displayDialogAsync(dialogUrl, dialogOptions, (asyncResult) => {
        if (asyncResult.status === Office.AsyncResultStatus.Failed) {
          reject(asyncResult.error);
          return;
        }

        this.dialog = asyncResult.value;

        this.dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg: any) => {
          this.close();
          // The message contains the full redirect URL with the sign-in response
          resolve({ url: arg.message });
        });

        this.dialog.addEventHandler(Office.EventType.DialogEventReceived, (arg: any) => {
          // 12006 = The dialog has been closed by the user.
          if (arg.error === 12006) {
            reject(new Error('Silent renew dialog closed by user.'));
          }
        });
      });
    });
  }

  public close(): void {
    if (this.dialog) {
      this.dialog.close();
      this.dialog = undefined;
    }
  }

  public get closed(): boolean {
    return !this.dialog;
  }

  public location = {
    // These are part of the IWindow interface but are not used in this implementation.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    assign: (): void => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    replace: (): void => {},
  };
}
